(function($) {$(document).ready(function() {
	let activeImg = 0;
	let lastImgIndex = $('.home-intro__bg--m .home-intro__bg-img').length - 1;

	if ($('.home-intro').length > 0) setInterval(nextImg, 5000);

	function nextImg() {
		let nextImg = activeImg + 1;
	
		if (nextImg > lastImgIndex) nextImg = 0;
	
		$('.home-intro__bg-img').removeClass('active');
	
		$('.home-intro__bg--m .home-intro__bg-img').eq(nextImg).addClass('active');
		$('.home-intro__bg--d .home-intro__bg-img').eq(nextImg).addClass('active');
	
		activeImg = nextImg;
	}
});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);